export const PriceSlashData = [
    {
      img: "./images/phones/image 772.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 773.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "40%",
    },
  
    {
      img: "./images/phones/image 774.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 775.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 776.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "10%",
    },
  
    {
      img: "./images/phones/image 777.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  ];
  
  export const PriceSlashDataI = [
    {
      img: "./images/phones/image 784.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 785.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "40%",
    },
  
    {
      img: "./images/phones/image 786.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 787.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 788.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 789.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "10%",
    },
  ];
  
  export const PriceSlashDataII = [
    {
      img: "./images/phones/image 791.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 792.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "40%",
    },
  
    {
      img: "./images/phones/image 791.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 794.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 794.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 795.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "10%",
    },
  ];
  
  export const PriceSlashDataIII = [
    {
      img: "./images/phones/image 797.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 798.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 799.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 800.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 801.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 796.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  ];
  
  export const PriceSlashDataIV = [
    {
      img: "./images/phones/image 803.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 804.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 805.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 802.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 806.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 807.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  ];
  
  export const PriceSlashDataV = [
    {
      img: "./images/phones/image 809.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 810.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 811.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 808.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 812.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  
    {
      img: "./images/phones/image 813.png",
      info: " Samsung Galaxy A50...",
      price: "₦ 100,000",
      slashed: "₦ 800,000",
      percentage: "20%",
    },
  ];
  
  export const OfficialStoreData = [
    {
      img: "./images/phones/Rectangle 2231.png",
      info: "IPHONES",
    },
  
    {
      img: "./images/phones/Rectangle 2233.png",
      info: "Andriod",
    },
  
    {
      img: "./images/phones/Rectangle 2235.png",
      info: "Basic Phone",
    },
  
    {
      img: "./images/phones/Rectangle 2232.png",
      info: "Ipads",
    },
  
    {
      img: "./images/phones/Rectangle 2234.png",
      info: "Tablets",
    },
  
    {
      img: "./images/phones/Rectangle 2236.png",
      info: "Education",
    },
  ];
  
  export const OfficialStoreDataI = [
    {
      img: "./images/phones/Rectangle 2238.png",
      info: "IPHONES",
    },
  
    {
      img: "./images/phones/Rectangle 2239.png",
      info: "Andriod",
    },
  
    {
      img: "./images/phones/Rectangle 2240.png",
      info: "Basic Phone",
    },
  
    {
      img: "./images/phones/Rectangle 2241.png",
      info: "Ipads",
    },
  
    {
      img: "./images/phones/Rectangle 2242.png",
      info: "Tablets",
    },
  
    {
      img: "./images/phones/Rectangle 2243.png",
      info: "Education",
    },
  ];
  
  export const OrderTableData = [
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
  ];
  
  export const OrderTableDataI = [
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/10/237746/1.jpg?7233",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/45/141566/1.jpg?9571",
      info: "KleanWater Laundry Starch",
    },
  
    {
      img: "https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/17/778023/1.jpg?9578",
      info: "Sunlight 2in1 Tropical",
    },
  ];
  
  export const OrderTableDataII = [
    {
      img: "./images/phones/Rectangle 2223.png",
      info: "IPHONES",
    },
  
    {
      img: "./images/phones/Rectangle 2224.png",
      info: "Andriod",
    },
  
    {
      img: "./images/phones/Rectangle 2225.png",
      info: "Basic Phone",
    },
  
    {
      img: "./images/phones/Rectangle 2226.png",
      info: "Ipads",
    },
  
    {
      img: "./images/phones/Rectangle 2227.png",
      info: "Tablets",
    },
  
    {
      img: "./images/phones/Rectangle 2228.png",
      info: "Education",
    },
  ];
  

  export const bannerImage = [
    {
      bannerImage1: "https://ng.jumia.is/cms/0-categories-tng/health-beauty/L1/Main_CB.jpg",
      bannerImage2: "https://ng.jumia.is/cms/0-categories-tng/health-beauty/L1/cb-grooming.jpg",
    },
  ];
  





export const ProductOrders = [
  {
  id: '1',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '2',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:3,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '3',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '4',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '5',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '6',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '7',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '8',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '9',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '10',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '11',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '12',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '13',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '14',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '15',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '16',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '17',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '18',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '19',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '20',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 90,000',
  slashedPrice:'₦ 110,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '21',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '22',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:3,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '23',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '24',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '25',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '26',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '27',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '28',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '29',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '30',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'UMIDIGI A7 Pro 6.3-Inch (4GB, 64GB ROM) Android 10.0, (16MP + 16MP + 5MP + 5MP) + 16MP 4150mAh...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://www.naijatechguide.com/wp-content/uploads/2020/05/Umidigi-A70-Pro.jpg',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '31',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},{
  id: '32',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '33',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦ 45,900',
  slashedPrice:'₦ 800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '34',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/66/218916/1.jpg?6847',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '35',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: 'Cubot Note 20, 6.5", 3GB+64GB, (Dual SIM) Quad Camera 12MP Android 10 NFC -Green...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '36',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '37',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '38',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '39',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦45,900',
  slashedPrice:'₦800,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
{
  id: '40',
  status: 'Draft',
  service_date: '6/30/2016',
  service_time: '2:17 PM',
  productName: '10.1 Inch Tablet PC RAM 2G ROM 32G Dual Card Camera Black...',
  address1: '6556 Evergreen Boulevard Apt 76',
  address2: 'Royalston, MA 01368',
  pay_type: 'hourly',
  pay_amount: 12,
  productImg:'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/11/647612/1.jpg?6915',
  productPrice:'₦90,000',
  slashedPrice:'₦110,000',
  ratingsCount:4,
  ratingsNumber:1103,
  percentDiscount:'20%'
},
];

 